import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AdminConfigCategoriesState } from './types/adminConfigCategoriesState';
import { CampaignConfigCategoryView } from '../../campaignConfigBuilder/types/CampaignConfigCategoryView';

const initialState: AdminConfigCategoriesState = {
  configCategories: [],
  isLoading: false,
  error: null,
  totalCount: 0,
  filters: {
    limit: 10,
    offset: 0,
    query: undefined,
    statuses: 'active,deleted',
    sort: undefined,
  },
};

const adminConfigCategoriesSlice = createSlice({
  name: 'adminConfigCategories',
  initialState,
  reducers: {
    setConfigCategoriesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setConfigCategoriesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setConfigCategories: (state, action: PayloadAction<{ items: CampaignConfigCategoryView[]; count: number }>) => {
      state.configCategories = action.payload.items;
      state.totalCount = action.payload.count;
    },
    addConfigCategory: (state, action: PayloadAction<CampaignConfigCategoryView>) => {
      state.configCategories.unshift(action.payload);
      state.totalCount += 1;
    },
    updateConfigCategory: (state, action: PayloadAction<CampaignConfigCategoryView>) => {
      const index = state.configCategories.findIndex(category => category.name === action.payload.name);
      if (index !== -1) {
        state.configCategories[index] = action.payload;
      }
    },
    updateConfigCategoriesFilters: (state, action: PayloadAction<Partial<AdminConfigCategoriesState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    deleteConfigCategory: (state, action: PayloadAction<string>) => {
      state.configCategories = state.configCategories.filter(category => category.name !== action.payload);
      state.totalCount = Math.max(0, state.totalCount - 1);
    },
  },
});

export const { setConfigCategoriesLoading, setConfigCategoriesError, setConfigCategories, addConfigCategory, updateConfigCategory, updateConfigCategoriesFilters, deleteConfigCategory } = adminConfigCategoriesSlice.actions;
export default adminConfigCategoriesSlice.reducer;
